import { lruCache } from '../../utils/lruCache';
import { ResponseError } from '../../errors/ResponseError';
import {
  fetchGetRegionExtensionItem,
  TGetRegionExtensionItemResponse,
} from '../../repositories/countryside-region-extension/v1/get-region-extension-item';
import { IApplicationContext } from '../../types/application';
import { TPrimitives } from '@cian/peperrors';

interface IFetchExtensionRegionParams {
  regionId: number;
}

const fetchExtensionRegion = async (
  { httpApi, logger }: IApplicationContext,
  parameters: IFetchExtensionRegionParams,
) => {
  try {
    const extensionRegionData: TGetRegionExtensionItemResponse = await fetchGetRegionExtensionItem({
      httpApi,
      parameters,
    });

    if (extensionRegionData.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchExtensionRegion',
        message: extensionRegionData.response.message || 'Код ответа не 200',
        details: {
          error: (extensionRegionData.response.errors || []) as unknown as TPrimitives[],
        },
      });
    }

    return extensionRegionData.response.regionItem;
  } catch (error) {
    logger.warning(error, { degradation: 'Расширение региона' });

    return null;
  }
};

const fetchExtensionRegionWithCache = lruCache(fetchExtensionRegion, { key: 'extensionRegion' });

export const fetchExtensionRegionCached = (context: IApplicationContext, parameters: IFetchExtensionRegionParams) => {
  return fetchExtensionRegionWithCache(`extensionRegion.${parameters.regionId}`, context, context, parameters);
};
